import { isToday } from 'date-fns';
import React from 'react';
import styled from 'styled-components';

import { useMarketTradesQuery } from 'api/queries/tradesQueries';
import NumberColored from 'components/basic/text/NumberColored';
import {
  DashboardTableHeader,
  DashboardTableRow,
} from 'components/orders/orderBook/sharedCss';
import { EXCHANGE_DECIMALS } from 'config/constants';
import { formatDateTime, formatTime } from 'lib/date';
import { formatNumber } from 'lib/display/formatting';
import {
  useSelectMarketStepSize,
  useSelectMarketTickSize,
} from 'reduxState/markets/listed/listedMarketsUtils';
import { useSelector } from 'reduxState/store';
import { scrollbarStyle } from 'styleShared';

const ContentWrap = styled.div`
  overflow-y: scroll;
  ${scrollbarStyle}

  font-family: var(--digitsFontFamily);
`;

export default function TradesTable() {
  const currentMarketPair = useSelector(
    state => state.markets.currentMarket.pair
  );
  const visibleDecimals =
    useSelectMarketTickSize(currentMarketPair)?.visibleDecimals ??
    EXCHANGE_DECIMALS;
  const visibleDecimalsBase =
    useSelectMarketStepSize(currentMarketPair)?.visibleDecimals ??
    EXCHANGE_DECIMALS;

  const { data: trades } = useMarketTradesQuery(currentMarketPair);

  return (
    <>
      <DashboardTableHeader $minimal={false}>
        <div>Price</div>
        <div>Quantity</div>
        <div>Time</div>
      </DashboardTableHeader>
      <ContentWrap key={currentMarketPair}>
        {(trades || []).map(trade => (
          <DashboardTableRow key={trade.fillId} $minimal={false}>
            <div>
              <NumberColored
                value={formatNumber(trade.price, {
                  fixedDecimals: visibleDecimals,
                })}
                color={trade.makerSide === 'sell' ? 'green' : 'red'}
              />
            </div>
            <div>
              {formatNumber(trade.quantity, {
                fixedDecimals: visibleDecimalsBase,
              })}
            </div>
            <div
              title={
                isToday(trade.time)
                  ? undefined
                  : formatDateTime(trade.time, { seconds: true })
              }
            >
              {formatTime(trade.time)}
            </div>
          </DashboardTableRow>
        ))}
      </ContentWrap>
    </>
  );
}
